export const flashcard = 'flashcard'
export const flashcardCategory = 'flashcard_category'
export const lesson = 'lesson'
export const post = 'post'
export const collection = 'list'
export const video = 'video'
export const studyPack = 'pack'
export const course = 'course'
export const poll = 'poll'

export const materialTypeLabels = {
  [flashcard]: 'Flashcards',
  [flashcardCategory]: 'Flashcard Categories',
  [lesson]: 'Lessons & Resources',
  [post]: 'Blog Posts',
  [collection]: 'Collections',
  [video]: 'Videos',
  [studyPack]: 'Study Packs',
  [course]: 'Courses',
  [poll]: 'Polls',
}
